export const PAGE_SIZE = 10;

export const CHAPTER_FINANCIAL_STATUS = {
  SUBMITTED: 1,
  ACCEPTED: 2,
  NOT_SUBMITTED: 3,
  REJECTED: 4,
  NONE: 0
};

export const CHAPTER_STATUS = {
  [CHAPTER_FINANCIAL_STATUS.ACCEPTED]: "Accepted",
  [CHAPTER_FINANCIAL_STATUS.NOT_SUBMITTED]: "Not Submitted",
  [CHAPTER_FINANCIAL_STATUS.SUBMITTED]: "Submitted",
  [CHAPTER_FINANCIAL_STATUS.REJECTED]: "Rejected"
};

export const FINANCIAL_REPORT_SUBTITLES = {
  CONTRACTOR: "Employee, Administrator, Bookkeeper & Other Contractor Data",
  Advertising: "Advertising Income",
  grant: "Contribution & Scholarship Expenses",
  Officer: "Chapter Board Member Data",
  Operating: "Operating Expenses",
  Scholarship: "Contribution & Scholarship Expenses",
  Standard: "Operating Income",
  Vendor: "Chapter Vendor Data"
};

export const REPORT_ITEM_TYPE = {
  EXPENSE: 1,
  REVENUE: 2,
  SUMMARY: 3
};

export const REPORT_ITEM_SUB_TYPE = {
  ADMINISTRATOR: 1,
  ADVERTISING: 2,
  CONTRIBUTIONS: 3,
  OFFICER: 4,
  OPERATING_EXPENSE: 5,
  SCHOLARSHIP: 6,
  OPERATING_INCOME: 7,
  VENDOR: 8,
  SUBMIT: 9
};

export const MEMBER_TYPE = {
  ADMIN: "administrator",
  EMPLOYEE: "employee",
  BOOKKEEPER: "bookkeeper",
  CONTRACTOR: "contractor"
};

export const FINANCIAL_ACCOUNT_TYPE_ID = {
  CHECKING: 1,
  INVESTMENT_BOND: 6,
  INVESTMENT_CD: 7,
  INVESTMENT_MONEY_MARKET: 3,
  INVESTMENT_MUTUAL_FUND: 4,
  INVESTMENNT_STOCK: 5,
  SAVINGS: 2
};

export const FINANCIAL_ACCOUNT_TYPE = {
  [FINANCIAL_ACCOUNT_TYPE_ID.CHECKING]: "Checking",
  [FINANCIAL_ACCOUNT_TYPE_ID.INVESTMENT_BOND]: "Investment - Bond",
  [FINANCIAL_ACCOUNT_TYPE_ID.INVESTMENT_CD]:
    "Investment - CD, maturity longer than 3 months",
  [FINANCIAL_ACCOUNT_TYPE_ID.INVESTMENT_MONEY_MARKET]:
    "Investment - Money Market",
  [FINANCIAL_ACCOUNT_TYPE_ID.INVESTMENT_MUTUAL_FUND]:
    "Investment - Mutual Fund",
  [FINANCIAL_ACCOUNT_TYPE_ID.INVESTMENNT_STOCK]: "Investment - Stock",
  [FINANCIAL_ACCOUNT_TYPE_ID.SAVINGS]: "Savings"
};
